import axios from "axios";
import { url } from "../config";

export const api = axios.create({
  baseURL: url,
  // timeout: 60000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

api.defaults.headers.common['X-Timezone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;

let _refreshPromise = null;

api.interceptors.response.use(
  response => response,
  async (error) => {
    const status = error.response?.status;
    const originalConfig = error.config;
    if (status === 401 && !originalConfig?._isAuthCheck && !originalConfig?._isRetry) {
      originalConfig._isRetry = true;
      if (!_refreshPromise) {
        _refreshPromise = api.post('/hub/auth/refresh', {}, { _isAuthCheck: true })
          .finally(() => { _refreshPromise = null; });
      }
      const refreshResponse = await _refreshPromise;
      if (refreshResponse?.status === 200) {
        return api(originalConfig);
      }
      localStorage.clear();
      sessionStorage.clear();
      window.dispatchEvent(new Event('auth:session-expired'));
    }
    return error.response;
  }
);
